var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs.length > 0)?_c('nx-tabs',{attrs:{"value":_vm.tab,"tabs":_vm.tabs,"color":"transparent"},on:{"input":_vm.changeTab}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }